// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c645816d","453":"01c0406d","553":"61981a69"}[chunkId] + ".chunk.js";
};